export function ensureOnlyOnePrimary(object, index, keyName = 'is_primary') {
  const selectedData = object[index]
  /*
   * value extracted is before update so:
   *  - false means set every other to false
   *  - true means set default to true
   */
  const purge = selectedData[keyName] 
  if (selectedData && !purge) {
    object.forEach((item, key) => {
      if (key !== index) {
        item[keyName] = false
      }
    })
  } else if (selectedData && purge){
    if (index !== 0){
      object[0][keyName] = true
    }else{
      object[1][keyName] = true
    }
  }
}
export default function selectOnePrimary(object, index, keyName = 'is_primary') {
  const selectedData = object[index]
  if (selectedData && !selectedData.is_primary) {
    object.forEach((item, key) => {
      if (key !== index) {
        item[keyName] = false
      }
    })
  }
}
